"use client";
import { colors } from "@areahub/theme";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { Button } from "@ui/components/button";
import { SectionTemplate } from "components/individuals/blocks";
import { ThemeColor } from "lib/gcms/theme-color";
import { ButtonProp } from "lib/gcms";

export interface PartnershipOpportunitiesSectionProps {
  title: string;
  subtitle: string;
  button: ButtonProp;
  color: string;
  bg: ThemeColor;
}

export default function ClientPartnershipOpportunitiesSection(
  props: PartnershipOpportunitiesSectionProps,
) {
  return (
    <SectionTemplate
      bg={props.bg}
      px={{
        base: 5,
        md: 16,
        lg: 20,
        xl: 48,
      }}
      py={{
        base: 10,
        md: 14,
        lg: 20,
      }}
      textAlign={"center"}
    >
      <Heading
        size="2xl"
        letterSpacing="tight"
        fontWeight="extrabold"
        lineHeight="normal"
      >
        {props.title}
      </Heading>

      <Flex align="start" mt="10">
        <Box
          as="span"
          mr={{
            base: 0.5,
            md: 2,
          }}
          mt={0.5}
        >
          <IoIosCheckmarkCircleOutline fontSize={20} />
        </Box>
        <Text
          fontSize={{
            base: "md",
            lg: "lg",
          }}
        >
          {props.subtitle}
        </Text>
      </Flex>

      <Button
        __type={
          props.button?.buttonAction as
            | "AUTH"
            | "LINK"
            | "OPEN_MODAL"
            | "OPEN_SEARCH"
        }
        href={props.button?.href as string}
        bgColor={colors.enterpriseColors.blue["300"]}
        color="white"
        mt={{
          base: 10,
          md: 14,
        }}
        py={{
          base: "6",
          lg: "8",
        }}
        px="5"
        w={{
          base: "140px",
          md: "160px",
          lg: "180px",
        }}
        {...props.button}
      />
    </SectionTemplate>
  );
}
